define.alias("shared/components/shared/addon-details-card", "settings/components/shared/addon-details-card");